import { useSystemSetting } from "@/api/services/admin/system-setting";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { MaintenanceForm } from "@/features/system-settings/components/maintenance/MaintenanceForm";
import { convertMaintenanceSettingResToForm } from "@/features/system-settings/utils/converts";

const MaintenancePage = () => {
  const { data, isLoading } = useSystemSetting();

  if (isLoading) return <LoadingPage />;

  const previousData = data?.data ? convertMaintenanceSettingResToForm(data.data) : undefined;

  return <MaintenanceForm previousData={previousData} />;
};

export default MaintenancePage;
